import React from "react";
import { useRouteError, Link } from "react-router-dom";

export function RootErrorElement() {
  const error = useRouteError();
  console.error(error);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      padding: "20px",
      textAlign: "center",
      fontFamily: "Outfit, sans-serif"
    }}>
      <h1 style={{ color: "#e53e3e" }}>¡Ups! Algo salió mal</h1>
      <p style={{ margin: "20px 0", color: "#4a5568" }}>
        {error.statusText || error.message || "Ha ocurrido un error inesperado."}
      </p>
      <Link 
        to="/" 
        style={{
          padding: "10px 20px",
          backgroundColor: "#fcac04",
          color: "black",
          textDecoration: "none",
          borderRadius: "5px",
          fontWeight: "bold"
        }}
        onClick={() => window.location.href = "/"}
      >
        Volver al inicio
      </Link>
    </div>
  );
}
